import moment from 'moment-timezone';

export const changeDateWithTimezone = (date: string, timezone): string => {
  return moment
    .tz(date, timezone)
    .utc()
    .utcOffset(moment.tz(timezone).utcOffset())
    .format('YYYY-MM-DDTHH:mm:ss');
};
